import { Info } from 'lucide-react'
import {
  EDIT_TEMPLATE_LABEL,
  TEMPLATE_HINT_CONSEQUENCE,
  TEMPLATE_HINT_MISSING_TOKEN,
} from 'src/modules/user/utils/appointment-type-form'
import type { LocationTemplateHintProps } from './location-template-hint.interface'
import classes from './location-template-hint.module.scss'

export function LocationTemplateHint({ templateName, token, onEditTemplate }: LocationTemplateHintProps) {
  return (
    <div role="status" className={classes.hint}>
      <Info size={18} aria-hidden className={classes.icon} />
      <p className={classes.text}>
        <span data-testid="location-template-hint-message">
          {templateName} {TEMPLATE_HINT_MISSING_TOKEN} <code className={classes.token}>{`{${token}}`}</code>
          {TEMPLATE_HINT_CONSEQUENCE}
        </span>{' '}
        <button type="button" className={classes.editButton} onClick={onEditTemplate}>
          {EDIT_TEMPLATE_LABEL}
        </button>
      </p>
    </div>
  )
}
